import EntityType from '@/models/Shared/EntityType';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationStatus from '@/models/Conversations/ConversationStatus';

export default class ConversationParticipantDto {
    id = '';
    tenantId = '';
    entityType: EntityType = EntityType.AgencyUser;
    entityId = '';
    displayName = '';
    avatar = '';
}